export default __webpack_public_path__ + "static/media/RezuanaHaque.39e845d0.pdf";